import { Badge, SvgComponent } from '@platform/ui'

type Props = {
  subActivityCount: number
}

export const SubActivityCountBadge = ({ subActivityCount }: Props) => {
  if (!subActivityCount) {
    return null
  }

  return (
    <Badge color="neutralWhite">
      <SvgComponent name="FolderBoldStroke" size="sm" />
      <span>{subActivityCount}</span>
    </Badge>
  )
}
